module.exports = __webpack_public_path__ + "img/arrow4.18f39fbf.svg";